import {
  GuideTourContextProvider,
  InvitationFlowModalContextProvider,
  LayoutMainBottomPaddingSpacingContextProvider,
  NotificationCountContextProvider,
} from 'context';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const LoggedUserProviders = ({ children }: Props) => (
  /* TODO: remove notification count context when websockets are ready */
  <NotificationCountContextProvider>
    <GuideTourContextProvider>
      <LayoutMainBottomPaddingSpacingContextProvider>
        <InvitationFlowModalContextProvider>
          {children}
        </InvitationFlowModalContextProvider>
      </LayoutMainBottomPaddingSpacingContextProvider>
    </GuideTourContextProvider>
  </NotificationCountContextProvider>
);
